import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ItemContentProps } from './types'

const Container = styled.div`
  position: relative;
`

const Content = styled.div<{
  isOwn: boolean
  isSuperUser: boolean
  isDeleting: boolean
}>`
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;
  background-color: ${({ theme, isOwn }) =>
    isOwn ? theme.colors.white : theme.colors.grey.grey_20};

  ${({ isSuperUser }) =>
    isSuperUser && 'padding-top: 2.5rem; padding-left: 1.5rem'};
  ${({ theme, isOwn }) =>
    isOwn && `border: 1px solid ${theme.colors.grey.grey_60}`};
  ${({ isDeleting, isOwn }) => isOwn && isDeleting && 'border-bottom-width: 0'};
`

const ItemContent: FunctionComponent<ItemContentProps> = ({
  isOwnItem,
  deletingItem,
  children,
  isSuperUser,
}) => (
  <Container>
    <Content
      isOwn={isOwnItem}
      isDeleting={deletingItem}
      isSuperUser={isSuperUser}>
      {children}
    </Content>
  </Container>
)

export default ItemContent
